import { useCallback } from 'react'

import { useTranslation } from 'react-i18next'

import { getRawColor } from 'shared/lib/getRawColor'
import { AllIcons } from 'shared/ui/app-icon/types'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { InfoItem } from 'shared/ui/info-item'
import { Paper } from 'shared/ui/paper'

import { mockData } from './model'
import s from './styles.module.scss'
import { PolicyPopup } from './ui'

interface Policy {
  titleKey: string
  description: string
  isShowReturnPolicy?: boolean
}

export const PoliciesSection = () => {
  const { t } = useTranslation()
  const { openDialog } = useDialogBottomSheet()

  const handleOpenPolicy = useCallback(
    (policy: Policy) => {
      openDialog({
        child: <PolicyPopup {...policy} />,
        backgroundColor: getRawColor('--white'),
      })
    },
    [openDialog],
  )

  return (
    <Paper
      padding={[0]}
      radius="16"
    >
      {mockData.map((policy) => (
        <InfoItem
          key={policy.id}
          className={s.infoItem}
          title={t(policy.title)}
          subtitle={t(policy.subtitle)}
          icon={policy.icon as AllIcons}
          onClick={() =>
            handleOpenPolicy({
              titleKey: t(policy.title),
              description: t(policy.description),
              isShowReturnPolicy: policy.isShowReturnPolicy,
            })
          }
        />
      ))}
    </Paper>
  )
}
